import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import School from '@mui/icons-material/School';
import Balance from '@mui/icons-material/Balance';
import VolunteerActivism from '@mui/icons-material/VolunteerActivism';
import { useTheme } from '@material-ui/core/styles';
import { readableHeading } from '../readablePalette';

const pillars = [
  {
    Icon: School,
    title: 'Fomento de la excelencia',
    text: 'Promoción de diplomados, cursos y actualizaciones jurídicas que ofrece el Colegio para fortalecer el ejercicio profesional.',
  },
  {
    Icon: Balance,
    title: 'Defensa del gremio',
    text: 'Espacios para la ética profesional y el impacto de los abogados en la resolución de conflictos familiares y sociales.',
  },
  {
    Icon: VolunteerActivism,
    title: 'Servicio a la comunidad',
    text: 'Difusión de jornadas de asistencia legal gratuita y programas de responsabilidad social del Colegio.',
  },
];

const EditorialVision = () => {
  const theme = useTheme();
  const h = readableHeading(theme);
  const gold = theme.palette.secondary.main;

  return (
    <Box component="section" sx={{ my: { xs: 5, md: 6 } }}>
      <Typography variant="overline" sx={{ color: gold, fontWeight: 700, letterSpacing: '0.14em', display: 'block', mb: 1 }}>
        Enfoque editorial
      </Typography>
      <Typography variant="h4" component="h2" sx={{ fontWeight: 700, color: h, fontFamily: 'Georgia, serif', mb: 1.5, maxWidth: 800 }}>
        El abogado como servidor social
      </Typography>
      <Typography variant="body1" color="textSecondary" sx={{ maxWidth: 800, lineHeight: 1.75, mb: 3 }}>
        La presencia del Colegio en TNO Network se centra en la <strong>revalorización del ejercicio legal</strong> y la
        promoción de sus servicios para el agremiado y la comunidad.
      </Typography>
      <Grid container spacing={2.5}>
        {pillars.map(({ Icon, title, text }) => (
          <Grid item xs={12} md={4} key={title}>
            <Box
              sx={{
                height: '100%',
                p: 2.5,
                borderRadius: 3,
                border: `1px solid rgba(196, 164, 93, 0.35)`,
                bgcolor: theme.palette.mode === 'dark' ? 'rgba(21, 37, 30, 0.75)' : theme.palette.background.paper,
                boxShadow: theme.palette.mode === 'dark' ? '0 8px 28px rgba(0,0,0,0.28)' : '0 8px 28px rgba(27,51,38,0.06)',
              }}
            >
              <Box sx={{ color: gold, mb: 1.5 }}>
                <Icon sx={{ fontSize: 36 }} />
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 800, color: h, mb: 1, fontFamily: 'Georgia, serif' }}>
                {title}
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ lineHeight: 1.65 }}>
                {text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default EditorialVision;
